export default __webpack_public_path__ + "static/media/envio-inactivo.47e95340.svg";